import { KpiCard, pctOfLeads } from "./Common";
import StageDurationCard from "./StageDurationCard";

export default function KpiRow({ stages, durationStages, fromStageId, toStageId, onFromChange, onToChange, stageDuration, stageDurationLoading }) {
  const hasData = !!stages?.length;

  const leadsTotal = hasData ? stages[0].total : 0;
  const lastStage = hasData ? stages[stages.length - 1] : null;
  const overallConversion = hasData ? pctOfLeads(lastStage.total, leadsTotal) : 0;

  const withPct = hasData ? stages.map((s) => ({ ...s, pct: pctOfLeads(s.total, leadsTotal) })) : [];
  const bottleneck = withPct.slice(1).reduce((worst, s, i) => {
    const prevPct = withPct[i].pct;
    const drop = prevPct - s.pct;
    return worst === null || drop > worst.drop ? { ...s, drop } : worst;
  }, null);

  return (
    <div className="mb-4 grid grid-cols-2 gap-2.5 ">
      <div className="grid grid-cols-2 gap-2.5">
        <KpiCard label="Total leads (period)" value={hasData ? leadsTotal : "-"} hint={stages?.[0]?.stage_name || "Entry stage"} />
        <KpiCard label={lastStage ? lastStage.stage_name : "Final stage"} value={hasData ? lastStage.total : "-"} hint={`${overallConversion}% of total leads`} trend={overallConversion >= 50 ? "up" : overallConversion > 0 ? "down" : "flat"} />
        <KpiCard label="Biggest drop-off" value={bottleneck ? `${bottleneck.pct}% of leads` : "-"} hint={bottleneck ? bottleneck.stage_name : "No data yet"} trend={bottleneck ? "down" : "flat"} />
        <KpiCard label="Active stages" value={hasData ? stages.length : "-"} hint="In the pipeline" />
      </div>
      <StageDurationCard stages={durationStages || []} fromStageId={fromStageId} toStageId={toStageId} onFromChange={onFromChange} onToChange={onToChange} summary={stageDuration} loading={stageDurationLoading} />
    </div>
  );
}
